module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#business",
      toString: function () {
        return this.url;
      }
    }